<template>
  <div :style="{ marginTop: '20px', paddingBottom: '80px' }">

    <div v-if="!loading">
      <form @submit.prevent="save_config">

        <div class="d-flex align-items-center mb-3 alerts-global-row">
          <span class="alerts-global-label">Reports Enabled</span>
          <b-form-select v-model="model.views_reports_enabled" :options="boolean_options" style="width:100px"></b-form-select>
        </div>

        <!-- General Settings -->
        <b-card no-body class="alert-section-card mb-2" data-section="isGeneralVisible">
          <b-card-header class="alert-section-header d-flex align-items-center" @click="toggle_div(toggle, 'isGeneralVisible')">
            <span class="alert-chevron mr-2" :class="{ open: toggle.isGeneralVisible }">&#9654;</span>
            <span class="alert-section-title">General Settings</span>
          </b-card-header>
          <b-collapse id="collapse-isGeneralVisible" :visible="!!toggle.isGeneralVisible">
            <b-card-body>
              <table width="100%" class="alert-settings-table" cellpadding="8">
                <tr data-field="views_reports_overnight_hour_offset">
                  <td class="alert-label">Overnight Hours Offset</td>
                  <td>
                    <b-form-input v-model="model.views_reports_overnight_hour_offset" type="text" :state="numericState('views_reports_overnight_hour_offset')" @input="validateNumeric('views_reports_overnight_hour_offset', $event, 0, 23)"></b-form-input>
                    <b-form-invalid-feedback :state="numericState('views_reports_overnight_hour_offset')">{{ numericFeedback('views_reports_overnight_hour_offset') }}</b-form-invalid-feedback>
                  </td>
                </tr>
              </table>

              <b-card v-if="isEffectiveAdmin" no-body class="alert-section-card mb-0 mt-3" data-section="isGeneralAdvVisible">
                <b-card-header class="alert-section-header d-flex align-items-center" @click="toggle_div(toggle, 'isGeneralAdvVisible')">
                  <span class="alert-chevron mr-2" :class="{ open: toggle.isGeneralAdvVisible }">&#9654;</span>
                  <span class="alert-section-title">Advanced</span>
                </b-card-header>
                <b-collapse id="collapse-isGeneralAdvVisible" :visible="!!toggle.isGeneralAdvVisible">
                  <b-card-body>
                    <table width="100%" class="alert-settings-table" cellpadding="8">
                      <tr data-field="employee_id_matching_enabled">
                        <td class="alert-label">Employee ID Matching Enabled</td>
                        <td>
                          <b-form-select v-model="model.employee_id_matching_enabled" :options="boolean_options" style="width:100px"></b-form-select>
                          <small class="text-muted d-block">Match by ID (TBN Ref ID / Samsara Username / Paycom eecode) instead of name</small>
                        </td>
                      </tr>
                    </table>
                  </b-card-body>
                </b-collapse>
              </b-card>
            </b-card-body>
          </b-collapse>
        </b-card>

        <!-- Vehicle Report -->
        <b-card no-body class="alert-section-card mb-2" data-section="isVehicleReportVisible">
          <b-card-header class="alert-section-header d-flex align-items-center" @click="toggle_div(toggle, 'isVehicleReportVisible')">
            <span class="alert-chevron mr-2" :class="{ open: toggle.isVehicleReportVisible }">&#9654;</span>
            <span class="alert-section-title">Vehicle Report</span>
          </b-card-header>
          <b-collapse id="collapse-isVehicleReportVisible" :visible="!!toggle.isVehicleReportVisible">
            <b-card-body>
              <SubsectionGroup label="Display &amp; Filters" :visible="!!toggle.grpVehicleReportDisplay" @toggle="toggle_div(toggle, 'grpVehicleReportDisplay')">
                <tr data-field="views_reports_vehicle_report_start_min_planned">
                  <td class="alert-label">Report Start Min Planned</td>
                  <td><b-form-select v-model="model.views_reports_vehicle_report_start_min_planned" :options="boolean_options" style="width:100px"></b-form-select></td>
                </tr>
                <tr data-field="views_reports_vehicle_report_start_stop_private_only">
                  <td class="alert-label">Start Stop Private Only</td>
                  <td><b-form-select v-model="model.views_reports_vehicle_report_start_stop_private_only" :options="boolean_options" style="width:100px"></b-form-select></td>
                </tr>
                <tr data-field="views_reports_vehicle_report_start_stop_contract_only">
                  <td class="alert-label">Start Stop Contract Only</td>
                  <td><b-form-select v-model="model.views_reports_vehicle_report_start_stop_contract_only" :options="boolean_options" style="width:100px"></b-form-select></td>
                </tr>
                <tr data-field="views_reports_vehicle_report_start_stop_columns">
                  <td class="alert-label">Start Stop Columns</td>
                  <td><b-form-input v-model="model.views_reports_vehicle_report_start_stop_columns" type="text"></b-form-input></td>
                </tr>
                <tr data-field="views_reports_vehicle_type_filter">
                  <td class="alert-label">Vehicle Type Filter</td>
                  <td>
                    <FilterSettingEditor
                      v-model="model.views_reports_vehicle_type_filter"
                      fieldKey="views_reports_vehicle_type_filter"
                      variant="wildcard"
                      :allow-raw-edit="isEffectiveAdmin"
                      @validation="onFilterValidation"
                    />
                  </td>
                </tr>
              </SubsectionGroup>

              <SubsectionGroup label="Timing Offsets" :visible="!!toggle.grpVehicleReportTiming" @toggle="toggle_div(toggle, 'grpVehicleReportTiming')">
                <tr data-field="views_reports_vehicle_report_start_threshold_minutes">
                  <td class="alert-label">Start Threshold Minutes</td>
                  <td>
                    <b-form-input v-model="model.views_reports_vehicle_report_start_threshold_minutes" type="text" :state="numericState('views_reports_vehicle_report_start_threshold_minutes')" @input="validateNumeric('views_reports_vehicle_report_start_threshold_minutes', $event, 0, 1440)"></b-form-input>
                    <b-form-invalid-feedback :state="numericState('views_reports_vehicle_report_start_threshold_minutes')">{{ numericFeedback('views_reports_vehicle_report_start_threshold_minutes') }}</b-form-invalid-feedback>
                  </td>
                </tr>
                <tr data-field="views_reports_vehicle_report_start_offset_minutes">
                  <td class="alert-label">Start Offset Minutes</td>
                  <td>
                    <b-form-input v-model="model.views_reports_vehicle_report_start_offset_minutes" type="text" :state="numericState('views_reports_vehicle_report_start_offset_minutes')" @input="validateNumeric('views_reports_vehicle_report_start_offset_minutes', $event, 0, 1440)"></b-form-input>
                    <b-form-invalid-feedback :state="numericState('views_reports_vehicle_report_start_offset_minutes')">{{ numericFeedback('views_reports_vehicle_report_start_offset_minutes') }}</b-form-invalid-feedback>
                  </td>
                </tr>
                <tr data-field="views_reports_vehicle_report_finish_offset_minutes">
                  <td class="alert-label">Finish Offset Minutes</td>
                  <td>
                    <b-form-input v-model="model.views_reports_vehicle_report_finish_offset_minutes" type="text" :state="numericState('views_reports_vehicle_report_finish_offset_minutes')" @input="validateNumeric('views_reports_vehicle_report_finish_offset_minutes', $event, 0, 1440)"></b-form-input>
                    <b-form-invalid-feedback :state="numericState('views_reports_vehicle_report_finish_offset_minutes')">{{ numericFeedback('views_reports_vehicle_report_finish_offset_minutes') }}</b-form-invalid-feedback>
                  </td>
                </tr>
                <tr data-field="views_reports_vehicle_report_round_to_minutes">
                  <td class="alert-label">Round To Nearest Minutes</td>
                  <td>
                    <b-form-input v-model="model.views_reports_vehicle_report_round_to_minutes" type="text" :state="numericState('views_reports_vehicle_report_round_to_minutes')" @input="validateNumeric('views_reports_vehicle_report_round_to_minutes', $event, 0, 60)"></b-form-input>
                    <b-form-invalid-feedback :state="numericState('views_reports_vehicle_report_round_to_minutes')">{{ numericFeedback('views_reports_vehicle_report_round_to_minutes') }}</b-form-invalid-feedback>
                  </td>
                </tr>
              </SubsectionGroup>

              <SubsectionGroup label="Vehicle Utilization Monthly" :visible="!!toggle.grpVehicleTypeMappings" @toggle="toggle_div(toggle, 'grpVehicleTypeMappings')">
                <tr data-field="views_reports_veh_monthly_monday_start_enabled">
                  <td class="alert-label">Weeks Start on Monday</td>
                  <td>
                    <b-form-select v-model="model.views_reports_veh_monthly_monday_start_enabled" :options="boolean_options" style="width:100px"></b-form-select>
                    <small class="text-muted d-block">Lay out the Vehicle Utilization Monthly calendar Monday through Sunday instead of Sunday through Saturday</small>
                  </td>
                </tr>
                <tr data-field="views_reports_veh_monthly_type_mappings">
                  <td class="alert-label">Vehicle Monthly Type Mappings</td>
                  <td>
                    <JsonKeyValueEditor v-model="model.views_reports_veh_monthly_type_mappings" fieldKey="views_reports_veh_monthly_type_mappings" @validation="onJsonValidation" :allow-raw-json="isEffectiveAdmin" keyLabel="Vehicle Type" valueLabel="Report Category"/>
                    <b-form-invalid-feedback :state="jsonState('views_reports_veh_monthly_type_mappings')">{{ jsonFeedback('views_reports_veh_monthly_type_mappings') }}</b-form-invalid-feedback>
                  </td>
                </tr>
              </SubsectionGroup>
            </b-card-body>
          </b-collapse>
        </b-card>

        <!-- Payroll -->
        <b-card no-body class="alert-section-card mb-2" data-section="isPayrollVisible">
          <b-card-header class="alert-section-header d-flex align-items-center" @click="toggle_div(toggle, 'isPayrollVisible')">
            <span class="alert-chevron mr-2" :class="{ open: toggle.isPayrollVisible }">&#9654;</span>
            <span class="alert-section-title">Payroll</span>
          </b-card-header>
          <b-collapse id="collapse-isPayrollVisible" :visible="!!toggle.isPayrollVisible">
            <b-card-body>
              <SubsectionGroup label="General" :visible="!!toggle.grpPayrollGeneral" @toggle="toggle_div(toggle, 'grpPayrollGeneral')">
                <tr data-field="views_reports_payroll_notes_enabled">
                  <td class="alert-label">Payroll Notes Enabled</td>
                  <td><b-form-select v-model="model.views_reports_payroll_notes_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
                </tr>
                <tr data-field="views_reports_payroll_company">
                  <td class="alert-label">Payroll Company</td>
                  <td><b-form-input v-model="model.views_reports_payroll_company" type="text"></b-form-input></td>
                </tr>
                <tr v-if="model.views_reports_payroll_company === 'paycom'" data-field="views_reports_paycom_terminal_group_compensation">
                  <td class="alert-label">Paycom Terminal Group Timezone (hours)</td>
                  <td>
                    <JsonKeyValueEditor v-model="model.views_reports_paycom_terminal_group_compensation" fieldKey="views_reports_paycom_terminal_group_compensation" @validation="onJsonValidation" :allow-raw-json="isEffectiveAdmin" keyLabel="Terminal Group" valueLabel="Hours Offset" valueType="number" keyPlaceholder="e.g. DRI" valuePlaceholder="e.g. 2"/>
                    <b-form-invalid-feedback :state="jsonState('views_reports_paycom_terminal_group_compensation')">{{ jsonFeedback('views_reports_paycom_terminal_group_compensation') }}</b-form-invalid-feedback>
                    <small class="text-muted d-block">Terminal group code &#8594; hours to add to CST for local time. Leave blank for no offset.</small>
                  </td>
                </tr>
                <tr v-if="user.tenant == 'starline-tbn-bdc7f899'" data-field="views_reports_payroll_categories">
                  <td class="alert-label">Payroll Categories</td>
                  <td><b-form-input v-model="model.views_reports_payroll_categories" type="text"></b-form-input></td>
                </tr>
                <tr v-if="user.tenant == 'starline-tbn-bdc7f899'" data-field="views_reports_payroll_category_report_config">
                  <td class="alert-label">Payroll Report Config</td>
                  <td>
                    <JsonObjectListEditor v-model="model.views_reports_payroll_category_report_config" fieldKey="views_reports_payroll_category_report_config" @validation="onJsonValidation" :allow-raw-json="isEffectiveAdmin" :columns="payroll_category_report_columns"/>
                    <b-form-invalid-feedback :state="jsonState('views_reports_payroll_category_report_config')">{{ jsonFeedback('views_reports_payroll_category_report_config') }}</b-form-invalid-feedback>
                  </td>
                </tr>
              </SubsectionGroup>

              <SubsectionGroup label="Payroll Push" :visible="!!toggle.grpPayrollPush" @toggle="toggle_div(toggle, 'grpPayrollPush')">
                <tr data-field="views_reports_driver_payroll_push_enabled">
                  <td class="alert-label">Payroll Push Enabled</td>
                  <td><b-form-select v-model="model.views_reports_driver_payroll_push_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
                </tr>
                <tr data-field="views_reports_driver_payroll_push_bookings_enabled">
                  <td class="alert-label">Payroll Push Bookings Enabled</td>
                  <td><b-form-select v-model="model.views_reports_driver_payroll_push_bookings_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
                </tr>
                <tr data-field="views_reports_driver_payroll_use_planned_start_as_actual">
                  <td class="alert-label">Payroll Use Planned Start As Actual</td>
                  <td><b-form-select v-model="model.views_reports_driver_payroll_use_planned_start_as_actual" :options="boolean_options" style="width:100px"></b-form-select></td>
                </tr>
                <tr data-field="views_reports_driver_payroll_max_off_duty_gap">
                  <td class="alert-label">Payroll Max Off Duty Gap</td>
                  <td>
                    <b-form-input v-model="model.views_reports_driver_payroll_max_off_duty_gap" type="text" :state="numericState('views_reports_driver_payroll_max_off_duty_gap')" @input="validateNumeric('views_reports_driver_payroll_max_off_duty_gap', $event, 0, 24)"></b-form-input>
                    <b-form-invalid-feedback :state="numericState('views_reports_driver_payroll_max_off_duty_gap')">{{ numericFeedback('views_reports_driver_payroll_max_off_duty_gap') }}</b-form-invalid-feedback>
                  </td>
                </tr>
                <tr data-field="views_reports_driver_payroll_minimum_hours">
                  <td class="alert-label">Payroll Minimum Hours</td>
                  <td>
                    <b-form-input v-model="model.views_reports_driver_payroll_minimum_hours" type="text" :state="numericState('views_reports_driver_payroll_minimum_hours')" @input="validateNumeric('views_reports_driver_payroll_minimum_hours', $event, 0, 24)"></b-form-input>
                    <b-form-invalid-feedback :state="numericState('views_reports_driver_payroll_minimum_hours')">{{ numericFeedback('views_reports_driver_payroll_minimum_hours') }}</b-form-invalid-feedback>
                  </td>
                </tr>
                <tr data-field="views_reports_driver_payroll_middle_day_min_hours">
                  <td class="alert-label">Payroll Middle Day Min Hours</td>
                  <td>
                    <b-form-input v-model="model.views_reports_driver_payroll_middle_day_min_hours" type="text" :state="numericState('views_reports_driver_payroll_middle_day_min_hours')" @input="validateNumeric('views_reports_driver_payroll_middle_day_min_hours', $event, 0, 24)"></b-form-input>
                    <b-form-invalid-feedback :state="numericState('views_reports_driver_payroll_middle_day_min_hours')">{{ numericFeedback('views_reports_driver_payroll_middle_day_min_hours') }}</b-form-invalid-feedback>
                  </td>
                </tr>
                <tr v-if="user.tenant == 'mtrwestern-tbn-3db5da5g7'" data-field="views_reports_driver_payroll_los_mappings">
                  <td class="alert-label">Payroll LOS Mappings</td>
                  <td><b-form-input v-model="model.views_reports_driver_payroll_los_mappings" type="text"></b-form-input></td>
                </tr>
                <tr v-if="user.tenant == 'mtrwestern-tbn-3db5da5g7'" data-field="views_reports_driver_payroll_ski_client_ids">
                  <td class="alert-label">Payroll Ski Client IDs</td>
                  <td><b-form-input v-model="model.views_reports_driver_payroll_ski_client_ids" type="text"></b-form-input></td>
                </tr>
                <tr v-if="user.tenant == 'mtrwestern-tbn-3db5da5g7'" data-field="views_reports_driver_payroll_push_filter">
                  <td class="alert-label">Payroll Push Filter</td>
                  <td>
                    <FilterSettingEditor
                      v-model="model.views_reports_driver_payroll_push_filter"
                      fieldKey="views_reports_driver_payroll_push_filter"
                      variant="wildcard"
                      :allow-raw-edit="isEffectiveAdmin"
                      @validation="onFilterValidation"
                    />
                  </td>
                </tr>
              </SubsectionGroup>

              <SubsectionGroup label="Payroll Summary Report" :visible="!!toggle.grpPayrollSummary" @toggle="toggle_div(toggle, 'grpPayrollSummary')">
                <tr v-if="telematics_type == 'SAMSARA'" data-field="views_reports_payroll_summary_samsara_username_enabled">
                  <td class="alert-label">Payroll Summary Samsara Username Enabled</td>
                  <td>
                    <b-form-select v-model="model.views_reports_payroll_summary_samsara_username_enabled" :options="boolean_options" style="width:100px"></b-form-select>
                    <small class="text-muted d-block">Show Samsara username as 2nd column in the Payroll Summary Report</small>
                  </td>
                </tr>
                <tr data-field="views_reports_payroll_summary_vehicles_to_exclude">
                  <td class="alert-label">Payroll Summary Vehicles To Exclude</td>
                  <td>
                    <b-form-input v-model="model.views_reports_payroll_summary_vehicles_to_exclude" type="text"></b-form-input>
                    <small class="text-muted d-block">Comma-delimited vehicle names; matching HOS events are excluded from Payroll Summary totals (case insensitive)</small>
                  </td>
                </tr>
                <tr data-field="views_reports_payroll_summary_remarks_to_exclude">
                  <td class="alert-label">Payroll Summary Remarks To Exclude</td>
                  <td>
                    <b-form-input v-model="model.views_reports_payroll_summary_remarks_to_exclude" type="text"></b-form-input>
                    <small class="text-muted d-block">Comma-delimited HOS remarks; matching events are excluded from Payroll Summary totals (case insensitive)</small>
                  </td>
                </tr>
              </SubsectionGroup>
            </b-card-body>
          </b-collapse>
        </b-card>

        <!-- Nightly Reports & Alerts -->
        <b-card no-body class="alert-section-card mb-2" data-section="isNightlyReportsVisible">
          <b-card-header class="alert-section-header d-flex align-items-center" @click="toggle_div(toggle, 'isNightlyReportsVisible')">
            <span class="alert-chevron mr-2" :class="{ open: toggle.isNightlyReportsVisible }">&#9654;</span>
            <span class="alert-section-title">Nightly Reports &amp; Alerts</span>
          </b-card-header>
          <b-collapse id="collapse-isNightlyReportsVisible" :visible="!!toggle.isNightlyReportsVisible">
            <b-card-body>
              <table width="100%" class="alert-settings-table" cellpadding="8">
                <tr data-field="views_reports_hos_nightly_report_config">
                  <td class="alert-label">HOS Nightly Report Config</td>
                  <td>
                    <JsonObjectListEditor v-model="model.views_reports_hos_nightly_report_config" fieldKey="views_reports_hos_nightly_report_config" @validation="onJsonValidation" :allow-raw-json="isEffectiveAdmin" :columns="hos_nightly_report_columns"/>
                    <b-form-invalid-feedback :state="jsonState('views_reports_hos_nightly_report_config')">{{ jsonFeedback('views_reports_hos_nightly_report_config') }}</b-form-invalid-feedback>
                  </td>
                </tr>
                <tr data-field="views_reports_nightly_alerts_report_config">
                  <td class="alert-label">Nightly Alerts Report Config</td>
                  <td>
                    <JsonObjectListEditor v-model="model.views_reports_nightly_alerts_report_config" fieldKey="views_reports_nightly_alerts_report_config" @validation="onJsonValidation" :allow-raw-json="isEffectiveAdmin" :columns="nightly_alerts_report_columns"/>
                    <b-form-invalid-feedback :state="jsonState('views_reports_nightly_alerts_report_config')">{{ jsonFeedback('views_reports_nightly_alerts_report_config') }}</b-form-invalid-feedback>
                  </td>
                </tr>
                <tr data-field="views_reports_nightly_report_config">
                  <td class="alert-label">Nightly Report Config</td>
                  <td>
                    <JsonObjectListEditor v-model="model.views_reports_nightly_report_config" fieldKey="views_reports_nightly_report_config" @validation="onJsonValidation" :allow-raw-json="isEffectiveAdmin" :columns="nightly_report_columns"/>
                    <b-form-invalid-feedback :state="jsonState('views_reports_nightly_report_config')">{{ jsonFeedback('views_reports_nightly_report_config') }}</b-form-invalid-feedback>
                  </td>
                </tr>
              </table>
            </b-card-body>
          </b-collapse>
        </b-card>

        <!-- Vehicles by Yard Report -->
        <b-card no-body class="alert-section-card mb-2" data-section="isYardReportVisible">
          <b-card-header class="alert-section-header d-flex align-items-center" @click="toggle_div(toggle, 'isYardReportVisible')">
            <span class="alert-chevron mr-2" :class="{ open: toggle.isYardReportVisible }">&#9654;</span>
            <span class="alert-section-title">Vehicles by Yard Report</span>
          </b-card-header>
          <b-collapse id="collapse-isYardReportVisible" :visible="!!toggle.isYardReportVisible">
            <b-card-body>
              <table width="100%" class="alert-settings-table" cellpadding="8">
                <tr data-field="maps_yard_report_recipients">
                  <td class="alert-label">Yard Report Recipients</td>
                  <td>
                    <b-form-input v-model="model.maps_yard_report_recipients" type="text"
                                  title="Comma-separated addresses. Leave blank to send nothing."></b-form-input>
                  </td>
                </tr>
                <tr data-field="maps_yard_report_send_days">
                  <td class="alert-label">Yard Report Schedule</td>
                  <td><b-form-select v-model="model.maps_yard_report_send_days" :options="yard_report_day_options" style="width:220px"></b-form-select></td>
                </tr>
                <tr data-field="maps_yard_report_send_hour">
                  <td class="alert-label">Yard Report Send Hour</td>
                  <td><b-form-select v-model="model.maps_yard_report_send_hour" :options="yard_report_hour_options" style="width:140px"></b-form-select></td>
                </tr>
              </table>
            </b-card-body>
          </b-collapse>
        </b-card>

        <!-- On-Time Performance (OTP) Report -->
        <b-card v-if="model.views_reports_otp_report_enabled" no-body class="alert-section-card mb-2" data-section="isOtpReportVisible">
          <b-card-header class="alert-section-header d-flex align-items-center" @click="toggle_div(toggle, 'isOtpReportVisible')">
            <span class="alert-chevron mr-2" :class="{ open: toggle.isOtpReportVisible }">&#9654;</span>
            <span class="alert-section-title">On-Time Performance (OTP) Report</span>
            <div class="ml-auto" @click.stop>
              <b-form-select v-model="model.views_reports_otp_report_enabled" :options="boolean_options" style="width:100px"></b-form-select>
            </div>
          </b-card-header>
          <b-collapse id="collapse-isOtpReportVisible" :visible="!!toggle.isOtpReportVisible">
            <b-card-body>
              <SubsectionGroup label="Report Options" :visible="!!toggle.grpOtpOptions" @toggle="toggle_div(toggle, 'grpOtpOptions')">
                <tr data-field="views_reports_otp_report_use_same_spot_and_pickup">
                  <td class="alert-label">Use Same Spot &amp; Pickup</td>
                  <td><b-form-select v-model="model.views_reports_otp_report_use_same_spot_and_pickup" :options="boolean_options" style="width:100px"></b-form-select></td>
                </tr>
                <tr data-field="views_reports_otp_stop_notes_enabled">
                  <td class="alert-label">Stop Notes Enabled</td>
                  <td><b-form-select v-model="model.views_reports_otp_stop_notes_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
                </tr>
                <tr data-field="views_reports_otp_arrivals_enabled">
                  <td class="alert-label">Stop Arrivals Enabled</td>
                  <td><b-form-select v-model="model.views_reports_otp_arrivals_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
                </tr>
                <tr data-field="views_reports_otp_report_adjust_stop_timezones">
                  <td class="alert-label">Adjust Stop Timezones</td>
                  <td><b-form-select v-model="model.views_reports_otp_report_adjust_stop_timezones" :options="boolean_options" style="width:100px"></b-form-select></td>
                </tr>
                <tr data-field="views_reports_otp_report_portico_enabled">
                  <td class="alert-label">Portico Enabled</td>
                  <td><b-form-select v-model="model.views_reports_otp_report_portico_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
                </tr>
                <tr data-field="views_reports_otp_report_skip_first_and_last_stop_enabled">
                  <td class="alert-label">Skip First &amp; Last Stop</td>
                  <td><b-form-select v-model="model.views_reports_otp_report_skip_first_and_last_stop_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
                </tr>
                <tr data-field="views_reports_otp_report_email_recipients">
                  <td class="alert-label">Email Recipients</td>
                  <td><b-form-input v-model="model.views_reports_otp_report_email_recipients" type="text"></b-form-input></td>
                </tr>
                <tr data-field="views_reports_otp_report_include_drivers_enabled">
                  <td class="alert-label">Include Drivers</td>
                  <td><b-form-select v-model="model.views_reports_otp_report_include_drivers_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
                </tr>
                <tr data-field="views_reports_otp_report_use_driver_assignments_enabled">
                  <td class="alert-label">Use Driver Assignments To Vehicles</td>
                  <td><b-form-select v-model="model.views_reports_otp_report_use_driver_assignments_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
                </tr>
                <tr data-field="views_reports_otp_report_send_filter_at_time">
                  <td class="alert-label">Send Filter At Time</td>
                  <td><b-form-input v-model="model.views_reports_otp_report_send_filter_at_time" type="text"></b-form-input></td>
                </tr>
                <tr data-field="views_reports_otp_report_multiday_config">
                  <td class="alert-label">Multiday Config</td>
                  <td>
                    <JsonTagListEditor v-model="model.views_reports_otp_report_multiday_config" fieldKey="views_reports_otp_report_multiday_config" @validation="onJsonValidation" :allow-raw-json="isEffectiveAdmin" valueLabel="Day Config" placeholder="e.g. 1"/>
                    <b-form-invalid-feedback :state="jsonState('views_reports_otp_report_multiday_config')">{{ jsonFeedback('views_reports_otp_report_multiday_config') }}</b-form-invalid-feedback>
                  </td>
                </tr>
              </SubsectionGroup>

              <SubsectionGroup label="Arrival &amp; Departure Thresholds" :visible="!!toggle.grpOtpThresholds" @toggle="toggle_div(toggle, 'grpOtpThresholds')">
                <tr data-field="views_reports_otp_report_arrival_early_minutes_limit">
                  <td class="alert-label">Arrival Early Minutes Limit</td>
                  <td>
                    <b-form-input v-model="model.views_reports_otp_report_arrival_early_minutes_limit" type="text" :state="numericState('views_reports_otp_report_arrival_early_minutes_limit')" @input="validateNumeric('views_reports_otp_report_arrival_early_minutes_limit', $event, 0, 1440)"></b-form-input>
                    <b-form-invalid-feedback :state="numericState('views_reports_otp_report_arrival_early_minutes_limit')">{{ numericFeedback('views_reports_otp_report_arrival_early_minutes_limit') }}</b-form-invalid-feedback>
                  </td>
                </tr>
                <tr data-field="views_reports_otp_report_arrival_late_minutes_limit">
                  <td class="alert-label">Arrival Late Minutes Limit</td>
                  <td>
                    <b-form-input v-model="model.views_reports_otp_report_arrival_late_minutes_limit" type="text" :state="numericState('views_reports_otp_report_arrival_late_minutes_limit')" @input="validateNumeric('views_reports_otp_report_arrival_late_minutes_limit', $event, 0, 1440)"></b-form-input>
                    <b-form-invalid-feedback :state="numericState('views_reports_otp_report_arrival_late_minutes_limit')">{{ numericFeedback('views_reports_otp_report_arrival_late_minutes_limit') }}</b-form-invalid-feedback>
                  </td>
                </tr>
                <tr data-field="views_reports_otp_report_departure_early_minutes_limit">
                  <td class="alert-label">Departure Early Minutes Limit</td>
                  <td>
                    <b-form-input v-model="model.views_reports_otp_report_departure_early_minutes_limit" type="text" :state="numericState('views_reports_otp_report_departure_early_minutes_limit')" @input="validateNumeric('views_reports_otp_report_departure_early_minutes_limit', $event, 0, 1440)"></b-form-input>
                    <b-form-invalid-feedback :state="numericState('views_reports_otp_report_departure_early_minutes_limit')">{{ numericFeedback('views_reports_otp_report_departure_early_minutes_limit') }}</b-form-invalid-feedback>
                  </td>
                </tr>
                <tr data-field="views_reports_otp_report_departure_late_minutes_limit">
                  <td class="alert-label">Departure Late Minutes Limit</td>
                  <td>
                    <b-form-input v-model="model.views_reports_otp_report_departure_late_minutes_limit" type="text" :state="numericState('views_reports_otp_report_departure_late_minutes_limit')" @input="validateNumeric('views_reports_otp_report_departure_late_minutes_limit', $event, 0, 1440)"></b-form-input>
                    <b-form-invalid-feedback :state="numericState('views_reports_otp_report_departure_late_minutes_limit')">{{ numericFeedback('views_reports_otp_report_departure_late_minutes_limit') }}</b-form-invalid-feedback>
                  </td>
                </tr>
              </SubsectionGroup>

              <SubsectionGroup label="Route Filters" :visible="!!toggle.grpOtpRouteFilters" @toggle="toggle_div(toggle, 'grpOtpRouteFilters')">
                <tr data-field="routes_charter_filter">
                  <td class="alert-label">Routes Charter Filter</td>
                  <td><b-form-input v-model="model.routes_charter_filter" type="text"></b-form-input></td>
                </tr>
                <tr data-field="routes_company_filter">
                  <td class="alert-label">Routes Company Filter</td>
                  <td><b-form-input v-model="model.routes_company_filter" type="text"></b-form-input></td>
                </tr>
                <tr data-field="routes_filter">
                  <td class="alert-label">Routes Filter</td>
                  <td><b-form-input v-model="model.routes_filter" type="text"></b-form-input></td>
                </tr>
                <tr data-field="routes_type_filter">
                  <td class="alert-label">Routes Type Filter</td>
                  <td><b-form-input v-model="model.routes_type_filter" type="text"></b-form-input></td>
                </tr>
                <tr data-field="routes_name_field">
                  <td class="alert-label">Routes Name Field</td>
                  <td><b-form-input v-model="model.routes_name_field" type="text"></b-form-input></td>
                </tr>
              </SubsectionGroup>
            </b-card-body>
          </b-collapse>
        </b-card>
        <div v-else class="d-flex align-items-center mb-3 alerts-global-row">
          <span class="alerts-global-label">On-Time Performance (OTP) Report</span>
          <b-form-select v-model="model.views_reports_otp_report_enabled" :options="boolean_options" style="width:100px"></b-form-select>
        </div>

        <!-- Trip Sheets & Dispatch Board -->
        <b-card no-body class="alert-section-card mb-2" data-section="isTripSheetsVisible">
          <b-card-header class="alert-section-header d-flex align-items-center" @click="toggle_div(toggle, 'isTripSheetsVisible')">
            <span class="alert-chevron mr-2" :class="{ open: toggle.isTripSheetsVisible }">&#9654;</span>
            <span class="alert-section-title">Trip Sheets &amp; Dispatch Board</span>
          </b-card-header>
          <b-collapse id="collapse-isTripSheetsVisible" :visible="!!toggle.isTripSheetsVisible">
            <b-card-body>
              <SubsectionGroup label="Trip Sheets" :visible="!!toggle.grpTripSheets" @toggle="toggle_div(toggle, 'grpTripSheets')">
                <tr data-field="views_reports_process_trip_sheets_enabled">
                  <td class="alert-label">Trip Sheets Enabled</td>
                  <td><b-form-select v-model="model.views_reports_process_trip_sheets_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
                </tr>
                <tr data-field="views_reports_trip_sheet_visible_fields">
                  <td class="alert-label">Trip Sheet Visible Fields</td>
                  <td><b-form-input v-model="model.views_reports_trip_sheet_visible_fields" type="text"></b-form-input></td>
                </tr>
                <tr v-if="user.tenant == 'polyad-9a91d945'" data-field="views_reports_process_trip_sheets_doc_type">
                  <td class="alert-label">Process Trip Sheets Doc Type</td>
                  <td><b-form-input v-model="model.views_reports_process_trip_sheets_doc_type" type="text"></b-form-input></td>
                </tr>
                <tr v-if="user.tenant == 'polyad-9a91d945'" data-field="views_reports_process_trip_sheets_email_recipients">
                  <td class="alert-label">Process Trip Sheets Email Recipients</td>
                  <td><b-form-input v-model="model.views_reports_process_trip_sheets_email_recipients" type="text"></b-form-input></td>
                </tr>
              </SubsectionGroup>

              <SubsectionGroup v-if="tenant_type == 'TBN'" label="Dispatch Board" :visible="!!toggle.grpDispatchBoard" @toggle="toggle_div(toggle, 'grpDispatchBoard')">
                <tr data-field="views_reports_dispatch_board_visible_fields">
                  <td class="alert-label">Dispatch Board Visible Fields</td>
                  <td><b-form-input v-model="model.views_reports_dispatch_board_visible_fields" type="text"></b-form-input></td>
                </tr>
                <tr data-field="views_reports_dispatch_board_current_departures_only">
                  <td class="alert-label">Current Departures Only</td>
                  <td><b-form-select v-model="model.views_reports_dispatch_board_current_departures_only" :options="boolean_options" style="width:100px"></b-form-select></td>
                </tr>
              </SubsectionGroup>

              <SubsectionGroup v-if="tenant_type == 'TBN'" label="Intrastate Report" :visible="!!toggle.grpIntrastateReport" @toggle="toggle_div(toggle, 'grpIntrastateReport')">
                <tr data-field="views_reports_intrastate_skip_routes">
                  <td class="alert-label">Skip Route Names</td>
                  <td><b-form-textarea v-model="model.views_reports_intrastate_skip_routes" style="field-sizing: content"/></td>
                </tr>
              </SubsectionGroup>
            </b-card-body>
          </b-collapse>
        </b-card>

        <!-- Samsara Reports -->
        <b-card v-if="telematics_type == 'SAMSARA'" no-body class="alert-section-card mb-2" data-section="isSamsaraReportsVisible">
          <b-card-header class="alert-section-header d-flex align-items-center" @click="toggle_div(toggle, 'isSamsaraReportsVisible')">
            <span class="alert-chevron mr-2" :class="{ open: toggle.isSamsaraReportsVisible }">&#9654;</span>
            <span class="alert-section-title">Samsara Reports</span>
          </b-card-header>
          <b-collapse id="collapse-isSamsaraReportsVisible" :visible="!!toggle.isSamsaraReportsVisible">
            <b-card-body>
              <table width="100%" class="alert-settings-table" cellpadding="8">
                <tr data-field="views_reports_samsara_safety_report_enabled">
                  <td class="alert-label">Samsara Safety Report Enabled</td>
                  <td><b-form-select v-model="model.views_reports_samsara_safety_report_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
                </tr>
                <tr data-field="views_reports_samsara_vehicle_mileage_enabled">
                  <td class="alert-label">Samsara Vehicle Mileage Enabled</td>
                  <td><b-form-select v-model="model.views_reports_samsara_vehicle_mileage_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
                </tr>
              </table>
            </b-card-body>
          </b-collapse>
        </b-card>

      </form>
    </div>
    <div v-else>
      <br/><br/>
      <b-spinner style="width: 3rem; height: 3rem;" label="Loading..."></b-spinner>
    </div>

  <div class="tc-sticky-save">
    <transition name="tc-save-slide">
    <div v-if="isDirty || saving" class="d-flex align-items-center justify-content-center">
      <span v-if="isDirty && !saving" class="tc-unsaved-label mr-3" @click="scrollToFirstDirtyField()" title="Click to scroll to unsaved field" style="cursor:pointer">&#9679; Unsaved changes</span>
      <b-btn size="lg" variant="success" @click="save_config" :disabled="saving">
          <b-spinner v-if="saving" small class="mr-1"></b-spinner>
          {{ saving ? 'Saving...' : 'Save' }}
        </b-btn>
      &nbsp;&nbsp;
      <b-btn size="lg" variant="secondary" @click="load_data(true)">Discard Changes</b-btn>
    </div>
    </transition>
  </div>
</div>

</template>
<script>
import {get_tenant_config_settings, update_tenant_config_settings} from '../networking/apis'
import filterValidationMixin from '../mixins/filter_validation_mixin'
import {mapState} from "vuex";
import numericValidationMixin from '../mixins/numeric_validation_mixin'
import jsonValidationMixin from '../mixins/json_validation_mixin'
import dirtyTrackingMixin from '../mixins/dirty_tracking_mixin'
import JsonKeyValueEditor from './JsonKeyValueEditor.vue'
import JsonTagListEditor from './JsonTagListEditor.vue'
import JsonObjectListEditor from './JsonObjectListEditor.vue'
import SubsectionGroup from './SubsectionGroup.vue'
import FilterSettingEditor from './FilterSettingEditor.vue'
import { ensureFilterKeys } from '../utils/filter_syntax'

export default {
  name: 'tenant_config',
  mixins: [filterValidationMixin, numericValidationMixin, jsonValidationMixin, dirtyTrackingMixin],
  components: {
    JsonKeyValueEditor,
    JsonTagListEditor,
    JsonObjectListEditor,
    SubsectionGroup,
    FilterSettingEditor,
  },

  data() {
    return {
      add_yard_model: {},
      manage_sos_yards: false,
      model: {},
      general_model: {},
      general_advanced_model: {},
      yard_report_day_options: [
        { value: '', text: 'Every day' },
        { value: 'mon', text: 'Mondays only' },
        { value: 'tue', text: 'Tuesdays only' },
        { value: 'wed', text: 'Wednesdays only' },
        { value: 'thu', text: 'Thursdays only' },
        { value: 'fri', text: 'Fridays only' },
        { value: 'sat', text: 'Saturdays only' },
        { value: 'sun', text: 'Sundays only' },
      ],
      // the tenant's own clock, like the capture
      yard_report_hour_options: Array.from({ length: 24 }, (v, h) => ({
        value: String(h),
        text: (h % 12 === 0 ? 12 : h % 12) + (h < 12 ? ' AM' : ' PM'),
      })),
      toggle: {
        isGeneralVisible: false,
        isGeneralAdvVisible: false,
        isVehicleReportVisible: false,
        isPayrollVisible: false,
        isNightlyReportsVisible: false,
        isYardReportVisible: false,
        isOtpReportVisible: false,
        isTripSheetsVisible: false,
        isSamsaraReportsVisible: false,
        grpVehicleReportDisplay: false,
        grpVehicleReportTiming: false,
        grpVehicleTypeMappings: false,
        grpPayrollGeneral: false,
        grpPayrollPush: false,
        grpPayrollSummary: false,
        grpOtpOptions: false,
        grpOtpThresholds: false,
        grpOtpRouteFilters: false,
        grpTripSheets: false,
        grpDispatchBoard: false,
        grpIntrastateReport: false,
      },
      summary: {},
      loading: true,
      isNotSysadmin: false,
      isSamaraType: false,
      yardsLength: 0,
      objectKeyList:[],
      boolean_options: [
        { text: 'True', value: 'True' },
        { text: 'False', value: 'False' },
      ],
      payroll_category_report_columns: [
        { key: 'category', label: 'Category', placeholder: 'e.g. Maintenance' },
        { key: 'email_recipients', label: 'Email Recipients', placeholder: 'comma-separated emails' },
      ],
      hos_nightly_report_columns: [
        { key: 'report_name', label: 'Report Name', placeholder: 'e.g. Main' },
        { key: 'selected_driver', label: 'Driver Filter', placeholder: 'optional' },
        { key: 'selected_status', label: 'Status Filter', placeholder: 'optional' },
        { key: 'remarks_filter', label: 'Remarks Filter', placeholder: 'optional' },
        { key: 'email_recipients', label: 'Email Recipients', placeholder: 'comma-separated emails' },
      ],
      nightly_alerts_report_columns: [
        { key: 'report_name', label: 'Report Name', placeholder: 'e.g. Late Alerts' },
        { key: 'alert_type', label: 'Alert Type', placeholder: 'e.g. LateAlert' },
        { key: 'alert_filter', label: 'Alert Filter', placeholder: 'optional' },
        { key: 'start_base', label: 'Start Base', placeholder: 'optional' },
        { key: 'email_recipients', label: 'Email Recipients', placeholder: 'comma-separated emails' },
      ],
      nightly_report_columns: [
        { key: 'report_type', label: 'Report Type', placeholder: 'e.g. OTP' },
        { key: 'email_recipients', label: 'Email Recipients', placeholder: 'comma-separated emails' },
      ],
      fieldPrefixSectionMap: [
        ['views_reports_payroll_summary_', 'isPayrollVisible'],
        ['views_reports_payroll_', 'isPayrollVisible'],
        ['views_reports_driver_payroll_', 'isPayrollVisible'],
        ['views_reports_vehicle_report_', 'isVehicleReportVisible'],
        ['views_reports_vehicle_type_filter', 'isVehicleReportVisible'],
        ['views_reports_veh_monthly_type_mappings', 'isVehicleReportVisible'],
        ['views_reports_hos_nightly_report_config', 'isNightlyReportsVisible'],
        ['views_reports_nightly_', 'isNightlyReportsVisible'],
        ['maps_yard_report_', 'isYardReportVisible'],
        ['views_reports_otp_', 'isOtpReportVisible'],
        ['routes_', 'isOtpReportVisible'],
        ['views_reports_process_trip_sheets_', 'isTripSheetsVisible'],
        ['views_reports_trip_sheet_visible_fields', 'isTripSheetsVisible'],
        ['views_reports_dispatch_board_', 'isTripSheetsVisible'],
        ['views_reports_intrastate_skip_routes', 'isTripSheetsVisible'],
        ['views_reports_samsara_', 'isSamsaraReportsVisible'],
        ['views_reports_overnight_hour_offset', 'isGeneralVisible'],
        ['views_reports_enabled', 'isGeneralVisible'],
        ['employee_id_matching_enabled', 'isGeneralVisible'],
      ],
      jsonFieldToggleMap: {
        views_reports_paycom_terminal_group_compensation: 'isPayrollVisible',
        views_reports_payroll_category_report_config: 'isPayrollVisible',
        views_reports_hos_nightly_report_config: 'isNightlyReportsVisible',
        views_reports_nightly_alerts_report_config: 'isNightlyReportsVisible',
        views_reports_nightly_report_config: 'isNightlyReportsVisible',
        views_reports_otp_report_multiday_config: 'isOtpReportVisible',
        views_reports_veh_monthly_type_mappings: 'isVehicleReportVisible',
      },
      fieldAdvancedSectionMap: {
        employee_id_matching_enabled: 'isGeneralAdvVisible',
      },
      fieldGroupMap: {
        views_reports_vehicle_report_start_min_planned: 'grpVehicleReportDisplay',
        views_reports_vehicle_report_start_stop_private_only: 'grpVehicleReportDisplay',
        views_reports_vehicle_report_start_stop_contract_only: 'grpVehicleReportDisplay',
        views_reports_vehicle_report_start_stop_columns: 'grpVehicleReportDisplay',
        views_reports_vehicle_type_filter: 'grpVehicleReportDisplay',
        views_reports_vehicle_report_start_threshold_minutes: 'grpVehicleReportTiming',
        views_reports_vehicle_report_start_offset_minutes: 'grpVehicleReportTiming',
        views_reports_vehicle_report_finish_offset_minutes: 'grpVehicleReportTiming',
        views_reports_vehicle_report_round_to_minutes: 'grpVehicleReportTiming',
        views_reports_veh_monthly_type_mappings: 'grpVehicleTypeMappings',
        views_reports_payroll_notes_enabled: 'grpPayrollGeneral',
        views_reports_payroll_company: 'grpPayrollGeneral',
        views_reports_paycom_terminal_group_compensation: 'grpPayrollGeneral',
        views_reports_payroll_categories: 'grpPayrollGeneral',
        views_reports_payroll_category_report_config: 'grpPayrollGeneral',
        views_reports_driver_payroll_push_enabled: 'grpPayrollPush',
        views_reports_driver_payroll_push_bookings_enabled: 'grpPayrollPush',
        views_reports_driver_payroll_use_planned_start_as_actual: 'grpPayrollPush',
        views_reports_driver_payroll_max_off_duty_gap: 'grpPayrollPush',
        views_reports_driver_payroll_minimum_hours: 'grpPayrollPush',
        views_reports_driver_payroll_middle_day_min_hours: 'grpPayrollPush',
        views_reports_driver_payroll_los_mappings: 'grpPayrollPush',
        views_reports_driver_payroll_ski_client_ids: 'grpPayrollPush',
        views_reports_driver_payroll_push_filter: 'grpPayrollPush',
        views_reports_payroll_summary_samsara_username_enabled: 'grpPayrollSummary',
        views_reports_payroll_summary_vehicles_to_exclude: 'grpPayrollSummary',
        views_reports_payroll_summary_remarks_to_exclude: 'grpPayrollSummary',
        views_reports_otp_report_use_same_spot_and_pickup: 'grpOtpOptions',
        views_reports_otp_stop_notes_enabled: 'grpOtpOptions',
        views_reports_otp_arrivals_enabled: 'grpOtpOptions',
        views_reports_otp_report_adjust_stop_timezones: 'grpOtpOptions',
        views_reports_otp_report_portico_enabled: 'grpOtpOptions',
        views_reports_otp_report_skip_first_and_last_stop_enabled: 'grpOtpOptions',
        views_reports_otp_report_email_recipients: 'grpOtpOptions',
        views_reports_otp_report_include_drivers_enabled: 'grpOtpOptions',
        views_reports_otp_report_use_driver_assignments_enabled: 'grpOtpOptions',
        views_reports_otp_report_send_filter_at_time: 'grpOtpOptions',
        views_reports_otp_report_multiday_config: 'grpOtpOptions',
        views_reports_otp_report_arrival_early_minutes_limit: 'grpOtpThresholds',
        views_reports_otp_report_arrival_late_minutes_limit: 'grpOtpThresholds',
        views_reports_otp_report_departure_early_minutes_limit: 'grpOtpThresholds',
        views_reports_otp_report_departure_late_minutes_limit: 'grpOtpThresholds',
        routes_charter_filter: 'grpOtpRouteFilters',
        routes_company_filter: 'grpOtpRouteFilters',
        routes_filter: 'grpOtpRouteFilters',
        routes_type_filter: 'grpOtpRouteFilters',
        routes_name_field: 'grpOtpRouteFilters',
        views_reports_process_trip_sheets_enabled: 'grpTripSheets',
        views_reports_trip_sheet_visible_fields: 'grpTripSheets',
        views_reports_process_trip_sheets_doc_type: 'grpTripSheets',
        views_reports_process_trip_sheets_email_recipients: 'grpTripSheets',
        views_reports_dispatch_board_visible_fields: 'grpDispatchBoard',
        views_reports_dispatch_board_current_departures_only: 'grpDispatchBoard',
        views_reports_intrastate_skip_routes: 'grpIntrastateReport',
      },
    }
  },
  async mounted() {
    this.load_data()
  },
  methods: {
    async load_data(silent = false) {
      if (!silent) this.loading = true
      this.objectKeyList = []
      let loaded = false
      try {
        const {value: { data = [] } } = await get_tenant_config_settings(this.user.tenant)
        this.summary = data.summary
        this.model = data.results
        ensureFilterKeys(this.model, ['views_reports_vehicle_type_filter', 'views_reports_driver_payroll_push_filter'])
        // new in #1760, so most tenant records lack it; without the key vue can't track the
        // select and Save never appears
        if (!('views_reports_veh_monthly_monday_start_enabled' in this.model))
          this.$set(this.model, 'views_reports_veh_monthly_monday_start_enabled', 'False')
        try {
          const entries = Object.entries(this.model);
          for (let [key,value] of entries) {
            if (this.isArrayType(value) || this.isPlainObject(value,key)) {
              let setting = JSON.stringify(value)
              //console.log('found plain object or array: key:'+key+ ' value: '+ setting);
              this.model[key] = setting
              this.objectKeyList.push(key)
            }
          }
        } catch(e) {
          console.log('error looping through keys',e)
        }
        loaded = true
      } catch(e) {
        this.$emit('showAlert', 'error retrieving data, try logging in again or contact support if needed', 'danger', 5000)
      }

      this.loading = false
      if (loaded) this._resetDirtyTracking()
    },
    async save_config() {
      try {
        this.saving = true
        this.flushNumericValidation()
        this.flushFilterValidation()
        if (this.hasNumericErrors()) {
          this.$emit('showAlert', 'Fix the highlighted field before saving', 'danger', 6000)
          this.scrollToFirstNumericError()
          return
        }
        if (this.hasFilterErrors()) {
          this.$emit('showAlert', 'Fix the highlighted filter field before saving', 'danger', 6000)
          this.scrollToFirstFilterError()
          return
        }
        if (this.hasJsonErrors()) {
          this.$emit('showAlert', 'Invalid JSON in field: ' + this.firstJsonErrorKey() + ' — ' + this.jsonFeedback(this.firstJsonErrorKey()), 'danger', 8000)
          this.expandAndScrollToJsonError()
          return
        }
        // Compute dirty keys before parsing (model still holds JSON strings matching snapshot).
        const dirtyKeys = new Set(Object.keys(this._dirtyFields()))
        if (dirtyKeys.size === 0) {
          this.$emit('showAlert', 'No changes to save', 'info', 3000)
          return
        }
        this.$emit('showAlert', 'Saving Changes', 'info',5000)
        const fullPayload = Object.assign({}, this.model)
        for (const objkey of this.objectKeyList) {
          try {
            if (fullPayload[objkey] && fullPayload[objkey].trim && fullPayload[objkey].trim() !== '') {
              fullPayload[objkey] = JSON.parse(fullPayload[objkey])
            }
          } catch (e) {
            this.$emit('showAlert', 'Invalid JSON in field: ' + objkey + ' — ' + e.message, 'danger', 8000)
            this.expandAndScrollToJsonError()
            this.load_data()
            return
          }
        }
        const payload = {}
        for (const key of dirtyKeys) {
          if (key in fullPayload) payload[key] = fullPayload[key]
        }
        await update_tenant_config_settings(this.user.tenant, payload)
        this._resetDirtyTracking()
        await this.load_data(true)
        this.$emit('showAlert', 'Configuration Saved', 'success',5000)
      } catch(e) {
        this.$emit('showAlert', this._saveErrorMessage(e), 'danger', 5000)
      }
      finally {
        this.saving = false
      }
    },
    set_tenant_id(id) {
      this.user.tenant = id
      this.load_data()
    },
    update_toggle_div(item,field,setting) {
      if (!item[field] && setting) {
        item[field] = !item[field];
        this.$forceUpdate();
      } else if (item[field] && !setting) {
        item[field] = !item[field];
        this.$forceUpdate();
      }
    },
    toggle_div(item,field) {
      item[field] = !item[field];
      this.$forceUpdate();
    },
    scrollToFirstDirtyField() {
      const field = this._firstDirtyField()
      if (!field) return

      let toggleKey = null
      if (this.jsonFieldToggleMap && this.jsonFieldToggleMap[field]) {
        toggleKey = this.jsonFieldToggleMap[field]
      }
      if (!toggleKey && this.fieldPrefixSectionMap) {
        for (const [prefix, key] of this.fieldPrefixSectionMap) {
          if (field.startsWith(prefix) || field === prefix) {
            toggleKey = key
            break
          }
        }
      }

      const advKey = this.fieldAdvancedSectionMap && this.fieldAdvancedSectionMap[field]
      const groupKey = this.fieldGroupMap && this.fieldGroupMap[field]
      const sectionWasClosed = toggleKey && this.toggle && !this.toggle[toggleKey]
      const advWasClosed = advKey && this.toggle && !this.toggle[advKey]
      const groupWasClosed = groupKey && this.toggle && !this.toggle[groupKey]

      if (toggleKey && this.toggle !== undefined) {
        this.$set(this.toggle, toggleKey, true)
      }
      if (advKey && this.toggle !== undefined) {
        this.$set(this.toggle, advKey, true)
      }
      if (groupKey && this.toggle !== undefined) {
        this.$set(this.toggle, groupKey, true)
      }

      const delay = (sectionWasClosed || advWasClosed || groupWasClosed) ? 420 : 0
      this.$nextTick(() => setTimeout(() => this._scrollToFieldElement(field), delay))
    },
    expandAndScrollToJsonError() {
      const fieldKey = this.firstJsonErrorKey()
      if (!fieldKey) return false

      const toggleKey = this.jsonFieldToggleMap[fieldKey]
      const advKey = this.fieldAdvancedSectionMap && this.fieldAdvancedSectionMap[fieldKey]
      const groupKey = this.fieldGroupMap && this.fieldGroupMap[fieldKey]
      const wasClosed = [toggleKey, advKey, groupKey].some(key => key && this.toggle && !this.toggle[key])

      for (const key of [toggleKey, advKey, groupKey]) {
        if (key && this.toggle !== undefined) {
          this.$set(this.toggle, key, true)
        }
      }

      const delay = wasClosed ? 420 : 0
      this.$nextTick(() => setTimeout(() => {
        const el = this.$el.querySelector(`[data-json-field="${fieldKey}"]`)
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'center' })
          el.classList.remove('tc-error-highlight')
          void el.offsetWidth
          el.classList.add('tc-error-highlight')
          el.addEventListener('animationend', () => el.classList.remove('tc-error-highlight'), { once: true })
        }
      }, delay))
      return true
    },
    _scrollToFieldElement(field) {
      const row = field ? this.$el.querySelector(`[data-field="${field}"]`) : null
      const jsonEl = field ? this.$el.querySelector(`[data-json-field="${field}"]`) : null

      let scrollTarget = this.$el
      if (row) {
        scrollTarget = row
      } else if (jsonEl) {
        scrollTarget = jsonEl
      }

      scrollTarget.scrollIntoView({ behavior: 'smooth', block: 'center' })

      let flashEl
      if (scrollTarget.tagName === 'TR') {
        const jsonEditor = scrollTarget.querySelector('[data-json-field]')
        flashEl = jsonEditor || scrollTarget.querySelector('input, select, textarea, .custom-select') || scrollTarget
      } else {
        flashEl = scrollTarget
      }

      flashEl.classList.remove('tc-error-highlight')
      void flashEl.offsetWidth
      flashEl.classList.add('tc-error-highlight')
      flashEl.addEventListener('animationend', () => flashEl.classList.remove('tc-error-highlight'), { once: true })
    },
    isPlainObject(value,key) {
      //console.log('isPlainObject, value:' + value + ', type of value:' + (typeof value))
      let objtype = (typeof value)
      if (objtype == "object") {
        if (value != null && !Array.isArray(value)) {
          return true
        }
        return false
      }
    },
    isArrayType(value) {
      return Array.isArray(value)
    },
  } ,
  computed:{
    ...mapState({
      user: state => state.profile.user,
      viewAs: state => state.profile.view_as,
    }),
    isEffectiveAdmin() {
      return this.user.role === 'admin' && this.viewAs !== 'non-admin'
    },
    telematics_type() {
      return this.user.telematics_types[this.user.tenant]
    },
    tenant_type() {
      return this.user.types[this.user.tenant]
    }
  },
  watch: {
    user: {
      deep: true,
      handler() {
        this.load_data()
      }
    }
  }
}
</script>
<style>
@import "../../node_modules/@syncfusion/ej2-base/styles/bootstrap5.css";
@import "../../node_modules/@syncfusion/ej2-inputs/styles/bootstrap5.css";
@import "../../node_modules/@syncfusion/ej2-lists/styles/bootstrap5.css";
@import "../../node_modules/@syncfusion/ej2-popups/styles/bootstrap5.css";
@import "../../node_modules/@syncfusion/ej2-buttons/styles/bootstrap5.css";
@import "../../node_modules/@syncfusion/ej2-navigations/styles/bootstrap5.css";
@import "../../node_modules/@syncfusion/ej2-splitbuttons/styles/bootstrap5.css";
@import "../../node_modules/@syncfusion/ej2-richtexteditor/styles/bootstrap5.css";

.alerts-global-row {
  padding: 10px 0;
  font-size: 18px;
  font-weight: bold;
}
.alerts-global-label {
  min-width: 220px;
}
.alert-section-card {
  border: 1px solid #dee2e6;
  border-radius: 4px;
}
.alert-section-header {
  cursor: pointer;
  user-select: none;
  background-color: #f8f9fa;
  padding: 10px 16px;
  font-size: 16px;
  font-weight: 600;
  color: #333;
  border-bottom: 1px solid #dee2e6;
}
.alert-section-header:hover {
  background-color: #e9ecef;
}
.alert-section-title {
  color: var(--fi-rail-accent);
  font-size: 17px;
}
.alert-chevron {
  display: inline-block;
  font-size: 12px;
  color: #666;
  transition: transform 0.2s ease;
}
.alert-chevron.open {
  transform: rotate(90deg);
}
.alert-settings-table td {
  vertical-align: middle;
  padding: 6px 10px;
}
.alert-settings-table td.alert-label {
  text-align: right;
  width: 340px;
  font-weight: 500;
  color: #444;
  white-space: nowrap;
}
.alert-settings-table td:not(.alert-label) {
  text-align: left;
}
</style>
